module.exports = __webpack_public_path__ + "img/timorleste.f97b6d7c.svg";